import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../components/auth";
import { SubscriptionView } from "./subscription";

const Plans = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const tenantId = Number(searchParams.get("tenantId") || 0);
  const companyId = Number(searchParams.get("companyId") || 0);

  sessionStorage.setItem("appId", "xero");

  const goConversation = () => {
    if (auth.user?.role === "User" && auth.user?.loginType) {
      navigate(`/${auth.user.loginType}/conversation`);
    } else {
      navigate("/conversation");
    }
  };

  return (
    <SubscriptionView
      subscription={true}
      hideClose={true}
      PlanToggle={goConversation}
      companyId={companyId || undefined}
      tenantId={tenantId || undefined}
      onSubscribed={goConversation}
    />
  );
};

export default Plans;
